/* ═══════════════════════════════════════════════════════════
   eRamis Boutique v6 — Interactions
   Hero slideshow · Mobile menu · Quick-add · Cart integration
   ═══════════════════════════════════════════════════════════ */

(function() {
  'use strict';

  /* ─── HERO SLIDESHOW ─── */
  function initHero() {
    var hero = document.getElementById('erHero');
    if (!hero) return;

    var slides = hero.querySelectorAll('.er-hero-slide');
    var total = slides.length;
    if (total <= 1) return;

    var current = 0;
    var autoplayAttr = parseInt(hero.getAttribute('data-autoplay'), 10);
    var autoplayMs = (autoplayAttr && autoplayAttr > 0 ? autoplayAttr : 7) * 1000;
    var timer = null;

    function goTo(i) {
      current = (i + total) % total;
      slides.forEach(function(s, idx) {
        s.classList.toggle('is-active', idx === current);
      });
      hero.querySelectorAll('.er-hero-dot').forEach(function(d) {
        var idx = parseInt(d.getAttribute('data-dot'), 10);
        d.classList.toggle('is-active', idx === current);
      });
    }

    function next() { goTo(current + 1); }
    function prev() { goTo(current - 1); }
    function start() { stop(); timer = setInterval(next, autoplayMs); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    hero.addEventListener('click', function(e) {
      var dot = e.target.closest('.er-hero-dot');
      if (!dot) return;
      var idx = parseInt(dot.getAttribute('data-dot'), 10);
      if (!isNaN(idx)) { goTo(idx); start(); }
    });

    var touchStartX = null;
    hero.addEventListener('touchstart', function(e) {
      touchStartX = e.touches[0].clientX;
      stop();
    }, { passive: true });
    hero.addEventListener('touchend', function(e) {
      if (touchStartX === null) return;
      var diff = e.changedTouches[0].clientX - touchStartX;
      if (Math.abs(diff) > 50) { diff < 0 ? next() : prev(); }
      touchStartX = null;
      start();
    }, { passive: true });

    hero.addEventListener('mouseenter', stop);
    hero.addEventListener('mouseleave', start);
    start();
  }

  /* ─── MOBILE MENU ─── */
  function initMobileMenu() {
    var toggles = document.querySelectorAll('.er-menu-toggle');
    var menu = document.getElementById('erMobileMenu');
    var closeBtns = document.querySelectorAll('.er-mobile-menu-close');
    if (!menu) return;

    toggles.forEach(function(btn) {
      btn.addEventListener('click', function() {
        menu.classList.add('is-open');
        document.body.style.overflow = 'hidden';
      });
    });

    closeBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        menu.classList.remove('is-open');
        document.body.style.overflow = '';
      });
    });

    menu.querySelectorAll('a').forEach(function(a) {
      a.addEventListener('click', function() {
        menu.classList.remove('is-open');
        document.body.style.overflow = '';
      });
    });
  }

  /* ─── QUICK-ADD WITH CART INTEGRATION ─── */
  function initQuickAdd() {
    var buttons = document.querySelectorAll('.er-quickadd');
    buttons.forEach(function(btn) {
      if (btn.dataset.bound === '1') return;
      btn.dataset.bound = '1';

      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();

        var id = btn.getAttribute('data-variant-id');
        if (!id) return;

        var originalText = btn.textContent;
        btn.textContent = 'Se adaugă...';
        btn.disabled = true;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: id, quantity: 1 })
        })
        .then(function(r) {
          if (!r.ok) throw new Error('add failed');
          return r.json();
        })
        .then(function() {
          return fetch('/cart.js').then(function(r) { return r.json(); });
        })
        .then(function(cart) {
          document.querySelectorAll('.er-cart-count').forEach(function(el) {
            el.textContent = cart.item_count;
          });
          var drawerCount = document.getElementById('erDrawerCount');
          if (drawerCount) drawerCount.textContent = cart.item_count;

          btn.textContent = 'Adăugat ✓';
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));

          setTimeout(function() {
            if (typeof window.erOpenCart === 'function') {
              window.erOpenCart();
            }
            btn.textContent = originalText;
            btn.disabled = false;
          }, 400);
        })
        .catch(function() {
          btn.textContent = 'Eroare — reîncearcă';
          setTimeout(function() {
            btn.textContent = originalText;
            btn.disabled = false;
          }, 1800);
        });
      });
    });
  }

  /* ─── CART COUNT SYNC ON LOAD ─── */
  function syncCartCount() {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        document.querySelectorAll('.er-cart-count').forEach(function(el) {
          el.textContent = cart.item_count;
        });
      })
      .catch(function() {});
  }

  /* ─── INIT ─── */
  function init() {
    initHero();
    initMobileMenu();
    initQuickAdd();
    syncCartCount();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init on Shopify Theme Editor events (for preview)
  document.addEventListener('shopify:section:load', init);
})();

/* ═══════════════════════════════════════════════════════════
   eRamis — Predictive Search (add-on)
   Ridica formularul .erh-search din eramis-header.liquid la
   custom element <predictive-search> din Dawn, fara sa modifice
   fisierul header-ului si fara sa atinga layout/theme.liquid.
   ═══════════════════════════════════════════════════════════ */

(function() {
  'use strict';

  var STYLE_ID = 'er-predictive-style';
  var FLAG = 'erPredictiveDone';

  /* Deduce calea catre assets pornind de la un script deja incarcat. */
  function assetBase() {
    var s = document.querySelector('script[src*="search-form"]')
         || document.querySelector('script[src*="global.js"]')
         || document.querySelector('script[src*="/assets/"]');
    if (!s) return null;
    return s.src.split('?')[0].replace(/[^/]+$/, '');
  }

  function injectStyles() {
    if (document.getElementById(STYLE_ID)) return;
    var css = [
      '.erh-search-wrap{position:relative;display:block;min-width:0;}',
      '.erh-search-wrap .erh-search{width:100%;box-sizing:border-box;}',
      '.erh-search-reset{flex:none;border:none;background:none;cursor:pointer;color:var(--er-smoke,#8a8078);font-size:15px;line-height:1;padding:2px 4px;}',
      '.erh-search-reset.hidden{display:none !important;}',
      '.erh-predictive{position:absolute;top:calc(100% + 10px);left:0;right:0;',
      'background:var(--er-paper,#FFFDF9);border:1px solid var(--er-hair,#e7e0d6);',
      'box-shadow:0 18px 44px -22px rgba(28,20,16,.5);max-height:min(70vh,560px);',
      'overflow-y:auto;z-index:200;display:none;text-align:left;padding:6px 0;}',
      'predictive-search[open] .erh-predictive,predictive-search[loading] .erh-predictive{display:block;}',
      '.erh-predictive .predictive-search__heading{font-size:11px;letter-spacing:.1em;text-transform:uppercase;color:var(--er-smoke,#8a8078);margin:10px 0 4px;padding:0 18px;}',
      '.erh-predictive .predictive-search__results-list{list-style:none;margin:0;padding:0;}',
      '.erh-predictive .predictive-search__item{display:flex;align-items:center;gap:12px;padding:9px 18px;text-decoration:none;color:var(--er-ink,#2a2320);width:100%;box-sizing:border-box;background:none;border:none;font-size:14px;text-align:left;cursor:pointer;}',
      '.erh-predictive .predictive-search__item:hover,.erh-predictive [aria-selected="true"] .predictive-search__item,.erh-predictive .predictive-search__item[aria-selected="true"]{background:var(--er-cream,#FAF7F0);}',
      '.erh-predictive .predictive-search__image{width:46px;height:46px;object-fit:cover;flex:none;}',
      '.erh-predictive .predictive-search__item-heading{margin:0;font-size:14px;font-weight:500;line-height:1.3;}',
      '.erh-predictive .predictive-search__search-for-button{border-top:1px solid var(--er-hair,#e7e0d6);margin-top:6px;padding-top:4px;}',
      '.erh-predictive .predictive-search__search-for-button .predictive-search__item{color:var(--er-plum,#3D1F3D);font-weight:600;}',
      '@media (max-width:990px){.erh-search-wrap{display:none;}}'
    ].join('');
    var el = document.createElement('style');
    el.id = STYLE_ID;
    el.textContent = css;
    document.head.appendChild(el);
  }

  /* Daca setarea predictive_search_enabled e off, scriptul Dawn nu e
     incarcat de theme.liquid — il aducem noi. */
  function ensureDawnAssets(cb) {
    if (window.customElements && customElements.get('predictive-search')) { cb(); return; }

    var base = assetBase();
    if (!base) { return; }

    if (!document.querySelector('link[href*="component-predictive-search"]')) {
      var link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = base + 'component-predictive-search.css';
      document.head.appendChild(link);
    }

    if (!document.querySelector('script[src*="predictive-search.js"]')) {
      var sc = document.createElement('script');
      sc.src = base + 'predictive-search.js';
      sc.defer = true;
      document.head.appendChild(sc);
    }

    customElements.whenDefined('predictive-search').then(cb);
  }

  /* Dawn construieste URL-ul de cautare hardcodat, fara options[prefix].
     Fara prefix, "tra" nu face match pe "Travel Kit ...". Rescriem metoda
     ca sa ceara prefix matching pe ultimul cuvant. */
  function patchPrefixMatching() {
    var Ctor = customElements.get('predictive-search');
    if (!Ctor || Ctor.prototype.erPrefixPatched) return;
    Ctor.prototype.erPrefixPatched = true;

    Ctor.prototype.getSearchResults = function(searchTerm) {
      var self = this;
      var queryKey = searchTerm.replace(' ', '-').toLowerCase();
      self.setLiveRegionLoadingState();

      if (self.cachedResults[queryKey]) {
        self.renderSearchResults(self.cachedResults[queryKey]);
        return;
      }

      var url = window.routes.predictive_search_url
        + '?q=' + encodeURIComponent(searchTerm)
        + '&options[prefix]=last'
        + '&resources[limit]=6'
        + '&section_id=predictive-search';

      fetch(url, { signal: self.abortController.signal })
        .then(function(response) {
          if (!response.ok) {
            self.close();
            throw new Error(response.status);
          }
          return response.text();
        })
        .then(function(text) {
          var node = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('#shopify-section-predictive-search');
          if (!node) { self.close(); return; }
          var resultsMarkup = node.innerHTML;
          self.allPredictiveSearchInstances.forEach(function(inst) {
            inst.cachedResults[queryKey] = resultsMarkup;
          });
          self.renderSearchResults(resultsMarkup);
        })
        .catch(function(error) {
          if (error && error.code === 20) return;
          self.close();
        });
    };
  }

  function prepareForm(form) {
    var input = form.querySelector('input[type="search"]');
    if (!input) return null;

    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-expanded', 'false');
    input.setAttribute('aria-owns', 'predictive-search-results');
    input.setAttribute('aria-controls', 'predictive-search-results');
    input.setAttribute('aria-haspopup', 'listbox');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('autocomplete', 'off');
    input.setAttribute('autocorrect', 'off');
    input.setAttribute('autocapitalize', 'off');
    input.setAttribute('spellcheck', 'false');

    if (!form.querySelector('button[type="reset"]')) {
      var reset = document.createElement('button');
      reset.type = 'reset';
      reset.className = 'erh-search-reset hidden';
      reset.setAttribute('aria-label', 'Sterge cautarea');
      reset.innerHTML = '&#10005;';
      form.appendChild(reset);
    }

    if (!form.querySelector('[data-predictive-search]')) {
      var results = document.createElement('div');
      results.className = 'erh-predictive';
      results.setAttribute('tabindex', '-1');
      results.setAttribute('data-predictive-search', '');
      form.appendChild(results);
    }

    if (!form.querySelector('.predictive-search-status')) {
      var status = document.createElement('span');
      status.className = 'predictive-search-status visually-hidden';
      status.setAttribute('role', 'status');
      status.setAttribute('aria-hidden', 'true');
      form.appendChild(status);
    }

    return form;
  }

  function upgrade() {
    var form = document.querySelector('.erh-search');
    if (!form || form.dataset[FLAG] === '1') return;
    if (form.closest('predictive-search')) { form.dataset[FLAG] = '1'; return; }
    if (!window.routes || !window.routes.predictive_search_url) return;

    if (!prepareForm(form)) return;
    form.dataset[FLAG] = '1';

    patchPrefixMatching();

    /* CRITIC: constructorul Dawn ruleaza in momentul upgrade-ului si cere
       this.querySelector('input[type="search"]'). Daca elementul e creat gol
       si formularul e mutat dupa aceea, constructorul crapa si nu se mai
       leaga niciun listener. Deci il construim intr-un document inert (fara
       browsing context, deci fara upgrade), cu formularul deja inauntru, si
       abia apoi il importam in pagina — upgrade-ul se face cu copii prezenti. */
    var inert = document.implementation.createHTMLDocument('');
    inert.body.innerHTML = '<predictive-search class="erh-search-wrap" data-loading-text="Se cauta..."></predictive-search>';
    var psInert = inert.body.firstElementChild;
    psInert.innerHTML = form.outerHTML;

    var ps = document.importNode(psInert, true);
    form.parentNode.replaceChild(ps, form);
  }

  function boot() {
    if (!document.querySelector('.erh-search')) return;
    injectStyles();
    ensureDawnAssets(function() {
      patchPrefixMatching();
      upgrade();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
